import { FiFile, FiImage, FiVideo } from 'react-icons/fi';
import isImageMimeType from './isImageMimeType.js';

const getFileIcon = (mimeType) => {
  if (!mimeType) {
    return FiFile;
  }

  if (isImageMimeType(mimeType)) {
    return FiImage;
  }

  if (mimeType.startsWith('video/')) {
    return FiVideo;
  }

  return FiFile;
};

export default getFileIcon;
